<template>
  <div>
    <!-- CRUD ENTITY -->
    <crud-view
      :crudEndpoint="crudEndpoint"
      @add="edit()"
      @filters-updated="filters = $event"
      @reset-filters="resetFilters"
      :fields="fields"
      :filters="filters"
      ref="crudView"
      :disablePagination="true"
    >
      <!-- FILTERS -->
      <template v-slot:filters>
        <filters v-model="filters" :letterTypes="letterTypes" />
      </template>

      <!-- RESULTS -->
      <template v-slot:results="{ results, sortChanged, pageIndex }">
        <results
          :pageIndex="pageIndex"
          :results="results"
          :fields="fields"
          @edit="edit"
          @remove="remove"
          @sort-changed="sortChanged"
        />
      </template>
    </crud-view>

    <!-- MODAL -->
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      button-size="sm"
      size="lg"
      ref="modal"
      :lazy="true"
      :title="obj.id ? $gettext('edit') : $gettext('add')"
      @ok.prevent="save"
    >
      <template v-slot:modal-footer>
        <modal-buttons @save="save" @cancel="cancel" />
      </template>
      <ValidationObserver ref="modalForm" slim>
        <Form v-model="obj" @save="save" :letterTypes="letterTypes" />
      </ValidationObserver>
    </b-modal>
  </div>
</template>

<script>
import CrudView from '@/shared/components/pages/CrudView.vue'

import Filters from './Filters.vue'
import Results from './Results.vue'
import Form from './Form.vue'

export default {
  components: {
    CrudView,
    Filters,
    Results,
    Form,
  },
  data() {
    return {
      crudEndpoint: 'agency|letterTemplate',
      filters: this.getDefaultFilters(),
      obj: {},
      fields: [
        {
          key: 'label',
          label: this.$gettext('label'),
          sortable: true,
        },
        {
          key: 'tag',
          label: this.$gettext('tag'),
          formatter: (val) => `##${val}##`,
          sortable: true,
        },
        {
          key: 'letter_type',
          label: this.$gettext('letter type'),
          formatter: (val) => {
            const v = this.letterTypes.find((el) => el.value === val).text
            return this.$gettext(v)
          },
          sortable: true,
        },
        {
          key: 'buttons',
          label: '',
          tdClass: 'tdWidth',
        },
      ],
    }
  },
  created() {
    this.letterTypes = [
      { value: 'client_document', text: this.$gettext('client document') },
      { value: 'supplier_document', text: this.$gettext('supplier document') },
    ]
  },
  computed: {
    api() {
      return this.crudEndpoint.split('|')
    },
  },
  methods: {
    async edit(id) {
      if (id) this.obj = await this.$crud[this.api[0]][this.api[1]].get({ id })
      else this.obj = {}

      this.$refs.modal.show()
    },
    async remove(id) {
      const accepted = await this.$confirmModal()

      if (accepted) {
        await this.$crud[this.api[0]][this.api[1]].delete({ id })

        this.resetSearch()

        this.$toastDeleteSuccess()
      }
    },
    async save() {
      const isValid = await this.$refs.modalForm.validate()

      if (isValid) {
        await this.$crud[this.api[0]][this.api[1]].save({ obj: this.obj, blocker: true })

        this.resetSearch()

        this.$toastSaveSuccess()

        this.cancel()
      } else {
        this.$toastInvalidForm()
      }
    },
    resetSearch() {
      this.resetFilters()
      this.$refs.crudView.search(true)
    },
    cancel() {
      this.$refs.modal.hide()
    },
    resetFilters() {
      this.filters = this.getDefaultFilters()
    },
    getDefaultFilters() {
      return {}
    },
  },
}
</script>
